import { useEffect, useRef } from 'preact/hooks';
import type { ComponentChildren, JSX } from 'preact';

type Props = {
  children: ComponentChildren;
  as?: keyof HTMLElementTagNameMap;
  class?: string;
  delay?: 0 | 1 | 2 | 3 | 4;
  style?: JSX.CSSProperties;
};

export function Reveal({ children, as = 'div', class: cls = '', delay = 0, style }: Props) {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const classes = ['reveal', delay ? `d${delay}` : '', cls].filter(Boolean).join(' ');

  const Tag = as as any;
  return (
    <Tag ref={ref as any} class={classes} style={style}>
      {children}
    </Tag>
  );
}
